export default __webpack_public_path__ + "static/media/icon-laptop.93cee22b.svg";